// ** React Imports
import { useState, useEffect, useRef, Fragment } from 'react'
import { ChevronDown } from 'react-feather'
import { useSelector } from "react-redux"
import { Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap"

const NavbarDropdown = () => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const [open, setOpen] = useState(false)
  const container = useRef(null)
  const [catData, setCatData] = useState([])
  const [catValue, setCatValue] = useState(4)
  const [catName, setCatName] = useState('RLM Subscription')

  useEffect(() => {
    setCatData(stores.woCates)
    const woCatObj = localStorage.getItem('catObj') ? JSON.parse(localStorage.getItem('catObj')) : ''
    if (woCatObj) {
      setCatValue(woCatObj.value)
      setCatName(woCatObj.label)
    }
  }, [stores.woCates.length])

  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  return (
    <Fragment>
  

      <div className='float-left navbar_dropdown d-none'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ border: open ? '1px solid #157387' : '0px solid #ededed' }}
      >
        <div onClick={() => setOpen(!open)} >
          <span className='span' style={{ fontWeight: '500', color: '#262626', fontSize: '16px' }}> {catName} </span>
          <button type="button" style={{ border: 'none', background: 'none', float: 'right' }}>
            <ChevronDown size={24} style={{ marginBottom: '4px' }} />
          </button>
          {open && (
            <div className="dropdown-wrapper-db" style={{ marginTop: catName ? '13px' : '40px', left: '224px', marginLeft: 0 }}>
              <ul className="dropdown-menu-db">
                {catData.map((item) => (
                  <li
                    className={catValue === item.value ? "dropdown-menu-db__select" : "dropdown-menu-db__item"} key={item.value}
                    onClick={() => {
                      setOpen(!open)
                      setCatValue(item.value)
                      setCatName(item.label)
                      localStorage.setItem('catObj', JSON.stringify(item))
                      localStorage.setItem('searchCategory', item ? item.value : '')
                      localStorage.setItem('typeObj', null)
                      localStorage.setItem('searchType', '')
                      localStorage.setItem('stageObj', null)
                      localStorage.setItem('searchStage', '')
                    }
                    }>{item.label}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default NavbarDropdown